import './iframe_embed.less';

import React from 'react';

import EmbeddedIframeSection from '../shared/embedded_iframe_section.jsx';

export default ({ height, uuid, iframeEmbedUrl, iframeTitle, bringToFore, ...rest }) => (
  <EmbeddedIframeSection
    uuid={uuid}
    height={height}
    bringToFore={bringToFore}
    iframeSrc={iframeEmbedUrl}
    iframeTitle={iframeTitle}
    {...rest}
  />
);
